import { Relatorio } from "./relatorios";

export class Perfil {
  id: number;
  descricao: string;
  telas: number[];
  relatorios: number[];
}

export class Sistema {
  id: number;
  descricao: string;
  tag: string;
  telas: Tela[];
  relatorios: Relatorio[];
}

export class Tela {
  id: number;
  descricao: string;
  tag: string;
  filhos: Tela[];
  tipo: number;
  idPai: number;
}
